export default "__VITE_ASSET__BNmRNVIH__"